// Public takedown request form (docs/PRODUCT.md "Curated-role posting rules").
import { z } from 'zod';

import { displayNameSchema } from './text.ts';

export const takedownRequestSchema = z.object({
  /** Public role id or its source URL — either identifies the listing. */
  roleId: z.uuid().nullable(),
  sourceUrl: z.url().max(500).nullable(),
  requesterName: displayNameSchema,
  requesterEmail: z.email().trim().toLowerCase(),
  reason: z.string().trim().min(10).max(2000),
  turnstileToken: z.string().min(1),
});
